var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-reservation-product" }, [
    _c("input", {
      attrs: { type: "hidden", name: "product_id" },
      domProps: { value: _vm.product.id },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "c-reservation-product__img" }, [
      _c("img", {
        staticClass: "c-img",
        attrs: {
          src: _vm.thumbnail(_vm.product.image, "sm"),
          alt: _vm.product.name,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-product__count" }, [
        _vm._v("\n            " + _vm._s(_vm.selectedQuantity) + "x\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-reservation-product__info" }, [
      _c("div", { staticClass: "c-reservation-product__category" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.product.category.name) + "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-product__name" }, [
        _vm._v("\n            " + _vm._s(_vm.product.name) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-product__price" }, [
        _c("span", { staticClass: "sc-price" }, [
          _vm._v(_vm._s(_vm.productPrice)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "sc-vat-info" }, [
          _vm._v(_vm._s(_vm.$t(_vm.pricesWithVat ? "withVat" : "withoutVat"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }